import { useFormik } from 'formik'
import * as Yup from 'yup'
import Ajax from '../../../Ajax'
import { Alert } from '../../..'
import Field from '../../form/fields/Field'
import { Button } from '@mui/material'
import { store } from '../../../stores/Store'
import React from 'react'


export default function WorkflowTemplateStepForm ({workflow, workflowStep = null}) {

    const initialValues = {
        label: workflowStep?.label,
        description: workflowStep?.description,
        additionalContentName: workflowStep?.additionalContentName,
        orderInd: typeof workflow?.orderInd === "number" ? workflow?.orderInd : workflow.steps.length,
        targetDateOffsetDays: workflowStep?.targetDateOffsetDays,
    }

    console.log(initialValues)

    React.useEffect(() => {
        formik.resetForm({values: initialValues})
    }, [workflowStep])

    var formik = useFormik({

        initialValues: initialValues,

        validationSchema: Yup.object({
            label: Yup.string().matches(/^[ ,.@!$%#';:?()[\]~_+=À-Ö\p{Sc}\p{So}\p{Mn}\p{P}\p{Z}À-ÿ\w\n]*$/u, "You have used some illegal characters").required("This field is required"),
            description: Yup.string().matches(/^[ ,.@!$%#';:?()[\]~_+=À-Ö\p{Sc}\p{So}\p{Mn}\p{P}\p{Z}À-ÿ\w\n]*$/u, "You have used some illegal characters").required("This field is required"),
            orderInd: Yup.number().required()
        }),

        onSubmit: async (values) => {
            var newStep = {...workflowStep, ...values}

            if (workflowStep) {
                await Ajax.Workflow.UpdateTemplateStep(newStep).then(async () => {
                    await store.AppStore.getWorkflows()
                    formik.resetForm()
                }).catch(() => {
                    Alert({message: "Failed to update step"})
                })
            } else {
                await Ajax.Workflow.CreateTemplateStep(workflow.uid, values).then(async () => {
                    await store.AppStore.getWorkflows()
                    store.AlertStore.Close()
                }).catch(() => {
                    Alert({message: "Failed to create step"})
                })
            }
        }
    })

    return (
        <form className="form" onSubmit={formik.handleSubmit}>
            <Field.Text
                formik
                name="label"
                label="Title"
                value={formik.values.label}
                warning={formik.submitCount && formik.errors.label ? formik.errors.label : null}
                onChange={formik.handleChange} />

            <Field.Text
                formik
                rows={3}
                variant="filled"
                name="description"
                label="Description"
                value={formik.values.description}
                warning={formik.submitCount && formik.errors.description ? formik.errors.description : null}
                onChange={formik.handleChange} />

            <div style={{maxWidth: "389px"}}>
                <Field.Select
                    formik
                    name="additionalContentName"
                    label="Additional step content (optional)"
                    value={formik.values.additionalContentName}
                    onChange={formik.handleChange}
                    options={[
                        {value: "SET_UP", label: "Case target date", help: "Includes a form which the user can use to set a target date for the Case."},
                        {value: "EVIDENCE", label: "Evidence & Documents", help: "Includes a checklist of evidence and documents which have been identified at being required duing the assessment."},
                        {value: null, label: "No additional content"},
                    ]} />

                <div className="form-fields" style={{borderLeft: formik.values.targetDateOffsetDays !== null ? "3px solid grey" : "none", paddingLeft: "6px", marginBottom: "10px"}}>
                    <Field.Checkbox 
                        formik
                        label="Step target date" 
                        value={formik.values.targetDateOffsetDays !== null} 
                        warning={false}
                        onChange={() => {
                            formik.setFieldValue("targetDateOffsetDays", formik.values.targetDateOffsetDays !== null ? null : 0)
                        }} />

                    {formik.values.targetDateOffsetDays !== null ? (
                        <Field.Text 
                            formik
                            type="number"
                            name="targetDateOffsetDays"
                            label="Target date offset days"
                            helpText="A target date will be made for this step but subtracting the amount of 'offset days' from the target date of the Case."
                            warning={formik.submitCount && formik.errors.targetDateOffsetDays ? formik.errors.targetDateOffsetDays : null}
                            value={formik.values.targetDateOffsetDays}
                            onChange={(e) => formik.handleChange(e)} />
                    ) : null}
                </div>
            </div>               

            {workflowStep && formik.dirty ? (
                <div className="header" style={{marginBottom: "15px"}}>
                    <Button
                        className="btn btn-sm"
                        color="secondary"
                        variant="contained"
                        disabled={formik.isSubmitting}
                        onClick={() => formik.resetForm()}>
                        Discard changes
                    </Button>

                    <Button
                        className="btn btn-sm"
                        color="success"
                        variant="contained"
                        disabled={formik.isSubmitting}
                        type="submit">
                        Save changes
                    </Button>
                </div>
            ) : null}

            {!workflowStep ? (
                <Button
                    className="btn btn-sm"
                    color="success"
                    variant="contained"
                    disabled={formik.isSubmitting}
                    type="submit">
                    Submit
                </Button>
            ) : null}
        </form>
    )
}